import React, { useState } from 'react';
import './Flashcard.css';
import AudioPlayer from './AudioPlayer';

const Flashcard = ({ data, isLocked, onAnswer, feedback, image, sound }) => {
  const [isFlipping, setIsFlipping] = useState(false);
  const [userAnswer, setUserAnswer] = useState('');

  const handleFlipCard = async (e) => {
    e.preventDefault();
    if (isLocked) return;

    setIsFlipping(true);
    // Vérifier que userAnswer est une chaîne avant de l'envoyer
    const safeUserAnswer = typeof userAnswer === 'string' ? userAnswer : '';
    onAnswer(safeUserAnswer, data);
    setUserAnswer('');
  };

  // Fonction pour déterminer si l'image est un drapeau
  const isFlag = (imagePath) => {
    return imagePath && imagePath.endsWith('.svg') && imagePath.includes('/images/Drapeau/');
  };

  // Fonction pour déterminer le texte alternatif
  const getAltText = (imagePath) => {
    if (isFlag(imagePath)) {
      return 'Drapeau associé à la question';
    }
    return 'Tableau associé à la question';
  };

  // Fonction pour déterminer la classe CSS en fonction du type d'image
  const getImageClass = (imagePath) => {
    return isFlag(imagePath) ? 'flag-image' : 'painting-image';
  };

  // Fonction pour déterminer la classe du conteneur
  const getFrameClass = (imagePath) => {
    return isFlag(imagePath) ? 'flag-container' : 'painting-frame';
  };

  // Vérifie s'il y a du contenu média (image ou son)
  const hasMedia = image || sound;

  // Détermine la réponse utilisateur à afficher (gère "Aucune réponse")
  const displayedUserAnswer = userAnswer ? userAnswer.trim() : 'Aucune réponse';

  return (
    <div className={`flashcard ${isFlipping ? 'flipped' : ''}`}>
      <div className={`flashcard-content ${!hasMedia ? 'no-media' : ''}`}>
        {/* Colonne de gauche : Image et Audio (affichée uniquement si média présent) */}
        {hasMedia && (
          <div className="flashcard-media">
            {image && (
              <div className={getFrameClass(image)}>
                <img
                  src={image}
                  alt={getAltText(image)}
                  className={getImageClass(image)}
                />
              </div>
            )}
            {sound && <AudioPlayer sound={sound} />}
          </div>
        )}

        {/* Conteneur pour la question et le formulaire */}
        <div className="flashcard-inner">
          <div className="flashcard-front">
            <div className="flashcard-question">
              <p>{data.question}</p>
            </div>
            <form className="answer-form" onSubmit={handleFlipCard}>
              <input
                type="text"
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                placeholder="Tapez votre réponse"
                className="user-answer-input"
                disabled={isLocked || isFlipping}
              />
              <button type="submit" className="flip-card-button" disabled={isLocked || isFlipping}>
                Vérifier
              </button>
            </form>
          </div>
          <div className="flashcard-back">
            <div className="flashcard-answer">
              {feedback && (
                <div className="answer-display">
                  <p className="correct-answer">
                    La bonne réponse est : {data.answers[data.correctAnswer]}
                  </p>
                  {!feedback.isCorrect && (
                    <p className="incorrect-answer">
                      Votre réponse : {displayedUserAnswer}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Feedback en dessous */}
      {feedback && (
        <div className={`answer-feedback ${feedback.isCorrect ? 'correct' : 'incorrect'}`}>
          <p>
            <span>{feedback.isCorrect ? '✅ Bonne réponse !' : '❌ Mauvaise réponse !'}</span>
            <br />
            <span className="feedback-info">{feedback.message}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default Flashcard;